import { useQuery } from '@tanstack/react-query'
import { knowledgeApi } from '@/lib/api'

/** Knowledge-base health for the Agents page Knowledge Base panel (Hestia). */
export function useKnowledgeStats() {
  return useQuery({
    queryKey: ['knowledge-stats'],
    queryFn: () => knowledgeApi.stats(),
    staleTime: 60_000,
  })
}
